import type { EventMinAge, LiveRoomMode } from '@pulsify/shared/dto'
import * as m from '~/paraglide/messages'
import type { EventPrivacy } from './event-privacy'

type MoreSettingsValues = {
  privacy: EventPrivacy
  liveRoomMode: LiveRoomMode
  rsvpEnabled: boolean
  plusOnesMax: number
  minAge: EventMinAge | null
  studentsOnly: boolean
  audienceNote?: string
  targetAgeMin?: number
  targetAgeMax?: number
  tags?: { amenityIds?: string[] }
}

const PRIVACY_LABEL: Record<EventPrivacy, () => string> = {
  public: m.eventVisibilityPublic,
  publicWithInvites: m.eventVisibilityPublic,
  request: m.eventVisibilityRequest,
  private: m.visibilityPrivateShort,
  members: m.visibilityMembersShort,
}

export function moreSettingsSummary(values: MoreSettingsValues): string {
  const parts = [
    PRIVACY_LABEL[values.privacy](),
    `${m.liveRoomFeature()} ${values.liveRoomMode === 'off' ? m.featureOff() : m.featureOn()}`,
  ]
  if (values.rsvpEnabled) parts.push(m.rsvpFeature())
  if (values.plusOnesMax > 0) parts.push(m.summaryPlusOnes({ count: String(values.plusOnesMax) }))
  if (values.minAge != null) parts.push(m.minAgeBadge({ age: String(values.minAge) }))
  if (values.studentsOnly) parts.push(m.studentsOnlyFeature())
  if (values.audienceNote?.trim()) parts.push(m.audienceNoteLabel())
  if (values.targetAgeMin != null || values.targetAgeMax != null) parts.push(m.targetAgeLabel())
  const amenities = values.tags?.amenityIds?.length ?? 0
  if (amenities > 0) parts.push(`${m.amenities()} ${amenities}`)
  return parts.join(' · ')
}
